import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Ticket } from '@marageti/z4-sdk/lib/tickets';
import { getFormattedDateShortMonthDDYYYY } from '@marageti/z4-lib';
import { SUBTYPE_DISPLAY_LABELS } from '../../pages/tickets/options';

type TicketSummaryItemProps = {
  ticket: Ticket;
};

const TicketSummaryItem = ({ ticket }: TicketSummaryItemProps) => {
  const subtypeLabel = SUBTYPE_DISPLAY_LABELS[ticket.ticketSubType] || ticket.ticketSubType;
  const formattedDate = getFormattedDateShortMonthDDYYYY(ticket.createdAt) || '';

  return (
    <Box sx={{ py: 0.5 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" fontWeight="bold">
          {subtypeLabel}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap', ml: 2 }}>
          {formattedDate}
        </Typography>
      </Box>
      <Typography
        component={Link}
        to={`/tickets/${ticket.id}`}
        rel="noopener noreferrer"
        variant="body1"
        color="text.secondary"
        sx={{
          textDecoration: 'none',
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        {ticket.title}
      </Typography>
    </Box>
  );
};

export default TicketSummaryItem;
